var map = {
	"./ar.json": 2045,
	"./ch.json": 9645,
	"./en.json": 3341,
	"./fr.json": 9998,
	"./gr.json": 7359,
	"./it.json": 5831,
	"./ru.json": 3991,
	"./sp.json": 6965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9607;